import React from 'react'
import config from '../../../config.json'
import $t from '../../../i18n'
import './ProviderTier.css'

// ProviderTier is a component that displays a tier indication
const ProviderTier = ({ tier, textSize, iconOnly = false }) => {
  const ImagePathByTier = new Map([
    ['Antidote', 'provider-tier-antidote'],
    ['Tier 1', 'provider-tier-1'],
    ['Tier 2', 'provider-tier-2']
  ])

  const TextKeyByTier = new Map([
    ['Antidote', 'tierTitle.antidote'],
    ['Tier 1', 'tierTitle.tier-1'],
    ['Tier 2', 'tierTitle.tier-2']
  ])

  const imagePath = ImagePathByTier.get(tier)
  if (!imagePath) {
    return null
  }

  const tierIcon = (
    <img
      src={config.gcpStorageUrl + `/icons/${imagePath}.svg`}
      className='tier-icon'
      alt={iconOnly ? `${tier} provider` : ''}
    />
  )

  if (iconOnly) {
    return tierIcon
  }

  return (
    <div className='provider-tier-container'>
      {tierIcon}
      <div className={`provider-header black ${textSize}`}>
        {$t(`providerPage.providerDetails.${TextKeyByTier.get(tier)}`)}
      </div>
    </div>
  )
}

export default ProviderTier
